export default {
  getFilterData(state) {
    return state.filterData;
  },
};
